define('../app/fukit/view/block/approvable.confirmation.modal.view',['require','exports','module','uikit/uikit','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),

  //Radio channels
      MODAL_CHANNEL = Radio.channel('UI.approvableModal');

  var ApprovableConfirmationModalView = UIKit.Modal2.extend({
    className: 'ui modal confirmation',
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      additionalClassNames: '',
      closable: true,

      // All buttons with the class "approve" will trigger an "approve" event that must be evalutated true to continue
      // with modal closing. This option can be overridden for custom onApprove evaluation.
      onApprove: function() {
        return false;
      },

      // Callback for successful save event.  This option can be overridden for custom OnSaveSuccess functionality.
      onSaveSuccess: function() {
        this.hide();
      },
    }),

    initialize: function() {
      UIKit.Modal2.prototype.initialize.call(this, arguments);

      this.$el.addClass(this.getOption('additionalClassNames'));
    },

    onFirstBeforeRender: function(modalView) {
      // The ShowModalOnEventBehavior has a "confirm" listener that hides the modal once the confirm button has been
      // pressed, so we need to turn that event off.
      modalView.off('confirm');

      // Handle modal cleanup and/or closing after a successful save
      MODAL_CHANNEL.reply('save:success', this.getOption('onSaveSuccess'), this);
    },

    header: {
      type: UIKit.Modal2.HeaderView,
    },

    content: null,

    actions: {
      components: [
        {
          type: UIKit.Modal2.DenyButtonView,
          text: 'Cancel',
        },
        {
          type: UIKit.Modal2.ConfirmButtonView,
          text: 'Save',
          color: 'primary',
          approvable: true,
          onPress: function() {
            this.trigger('save:success');
            MODAL_CHANNEL.request('save:success');
          },
        },
      ],
    },
  });

  module.exports = ApprovableConfirmationModalView;
});

